<template>
    <div>
        <template v-if="loading">
            <i class="fa fa-spin fa-spinner"></i> Loading
        </template>
        <template v-else>
            <vue-headful :title="'[Report] '+report.report_name+' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/reports">Saved Reports</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{ report.report_name }}
                    </li>

                </ol>
            </nav>

            <h4 class="page-header">
                {{ report.report_name }}
            </h4>

            <div class="row">
                <div class="col-lg-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            Report Details

                            <div class="pull-right">
                                <template v-if="canView">
                                    <router-link :to="`/reports/custom/${report.id}`" class="btn btn-sm btn-warning" v-if="report.report_type === 'Custom'">
                                        <i class="fa fa-list"></i> Generate
                                    </router-link>
                                    <router-link :to="`/reports/downline/${report.id}`" class="btn btn-sm btn-warning" v-if="report.report_type === 'Downline'">
                                        <i class="fa fa-list"></i> Generate
                                    </router-link>
                                </template>

                                <template v-if="report.user_id === $store.state.user.id">
                                    <button type="button" class="btn btn-sm btn-default" v-on:click="edit_mode = !edit_mode" v-if="false"><i class="fa fa-edit"></i> Edit</button>
                                    <router-link :to="`/reports/delete/${report.id}`" class="btn btn-sm btn-default">
                                        <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                    </router-link>
                                </template>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 text-md-right text-muted">Report Name:</div>
                                <div class="col-md-7">
                                    <div v-if="!edit_mode">
                                        {{ report.report_name }}
                                    </div>
                                    <div v-if="edit_mode">
                                        <b-form-input v-model="report.report_name" size="sm" placeholder="Enter Unique Report Name" class="mb-1" />
                                        <button type="button" v-on:click="updateReport()" class="btn btn-xs btn-success" :disabled="updating">Update</button>
                                        <button type="button" v-on:click="edit_mode = !edit_mode" class="btn btn-xs btn-secondary" :disabled="updating">Cancel</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 text-md-right text-muted">Report Type:</div>
                                <div class="col-md-7">
                                    {{ report.report_type }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 text-md-right text-muted">Created By:</div>
                                <div class="col-md-7">
                                    {{ report.first_name }} {{ report.last_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 text-md-right text-muted">Accessibility:</div>
                                <div class="col-md-7">
                                    <label class="badge badge-info" v-if="report.is_public == 1">Public</label>
                                    <label class="badge badge-danger" v-else>Private</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 col-md-4 text-md-right text-muted">Export Type:</div>
                                <div class="col-md-7">
                                    <span v-if="settings.export_type && settings.export_type === 'pdf'"><i class="fa fa-file-pdf"></i> PDF</span>
                                    <span v-else><i class="fa fa-file-excel"></i> XLSX</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Schedules ({{ schedules.length }})</strong>

                            <div class="pull-right" v-if="can_edit">
                                <router-link :to="`/reports/schedules/${report.id}`" class="btn btn-sm btn-default"><i class="fa fa-clock"></i> Edit</router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-for="(schedule, i) in schedules">
                                <hr v-if="i > 0" />
                                <schedule-name :schedule="schedule" />
                                <ul>
                                    <li v-for="user in schedule.users">
                                        {{ user.last_name }},  {{ user.first_name }} (<a :href="`mailto:${user.email}`">{{ user.email }}</a>) <label class="badge badge-warning" v-if="user.is_active === 0">Inactive</label>
                                    </li>
                                    <li v-for="(email, j) in schedule.emails">
                                        <a :href="`mailto:${email.email_address}`">{{ email.email_address }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header"><strong>Saved Export from Schedules ({{ files.length }})</strong></div>
                        <div class="card-body">
                            <files-list-table :files="files" />
                        </div>
                    </div>

                    <div class="card" v-if="false">
                        <div class="card-header">Report Users Go Here</div>
                        <div class="card-body">
                            Here you can assign a saved report to users with the VIEW permission only
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-12">
                    <div class="card">
                        <div class="card-header">Description</div>
                        <div class="card-body">
                            {{ report.description ? report.description : '--' }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                updating: false,
                edit_mode: false,
                can_edit: false,
                id: this.$route.params.id,
                report: {},
                schedules: [],
                files: [],
            }
        },

        watch: {

        },

        computed: {

            canView(){
                //Check if Public
                if(this.report.is_public == 1)
                {
                    return true;
                }

                //Check permissions
                if(this.$root.hasPermission('reports.manage.all'))
                {
                    return true;
                }

                //Check if user owns the report and has permission
                if(this.$store.state.user && this.report.user_id == this.$store.state.user.id && this.$root.hasPermission('reports.manage.own'))
                {
                    return true;
                }

                //NOPE
                return false;
            },

            settings(){
                return JSON.parse(this.report.filter_fields);
            }
        },

        methods: {
            //Get the Agent
            getReport(){
                //Send it
                this.$http.get('/reports/view/'+this.id)
                    .then(response => {
                        //Set the agent
                        this.report = response.data.report;
                        this.schedules = response.data.schedules;
                        this.can_edit = response.data.can_edit;
                        this.files = response.data.files;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            updateReport(){
                //Send it
                this.updating = true;

                //Send it
                this.$http.post('/reports/save', {id: this.report.id, report_type: this.report.report_type, report_name: this.report.report_name})
                        .then(response => {
                            //Alert
                            this.$toastr.s('Report Saved');

                            //Reset
                            this.edit_mode = false;
                        })
                        .catch(error => {
                            //Check for error
                            if(error.response.status === 422)
                            {
                                //Display validation errors
                                this.errors = error.response.data.errors;

                                //Alert
                                this.$toastr.e('Validation Errors Occurred');
                            }
                            else
                            {
                                //Alert the user
                                this.$toastr.e(error.response.data, 'Failed to Generate Report');
                            }
                        })
                        .then(() => {
                            //Reset
                            this.updating = false;
                        });
            },
        },

        mounted() {
            //Fetch
            this.getReport();
        }
    }
</script>
